import { Link } from 'react-router-dom'
import { Wallet, Landmark, BadgePercent, HandCoins, ChevronRight, UserPlus, Bone } from 'lucide-react'

// Reports landing — a grid of report / inspection tools. These are read-only
// range reports for inspection (no editing of past records). More tools slot in
// as sibling cards. Order here is the order on screen.
const TOOLS = [
  {
    to: '/reports/newcase',
    icon: UserPlus,
    title: 'เคสนัดใหม่ประจำวัน',
    desc: 'HN ที่เปิดใหม่ในแต่ละวัน พร้อมนัดหมายของคนไข้คนนั้น · กรองตามวันที่ สาขา ประเภทนัดหมาย · จัดกลุ่มตามประเภทนัดหมาย ที่มา สาขา หรือวันที่ · เห็นเคสที่เปิด HN แล้วยังไม่มีนัด',
  },
  {
    to: '/reports/revenue',
    icon: Wallet,
    title: 'รายรับ',
    desc: 'ตรวจสอบรายรับตามช่วงวันที่ · แยกตามสาขาและหมอ · ดูรายการเรียกเก็บของแต่ละเคส (อ่านอย่างเดียว)',
  },
  {
    to: '/reports/reimbursement?tab=ledger',
    icon: Landmark,
    title: 'รายการตามเบิก',
    desc: 'รายการที่เก็บเงินจากผู้จ่ายภายนอกแทนคนไข้ (ภาครัฐ · ประกัน · แพลตฟอร์ม · พาร์ทเนอร์ · บริษัท) · สรุปยอดตามผู้จ่าย ทำเครื่องหมายรับแล้ว ส่งออก CSV/PDF · นำเข้าไฟล์สรุปการจ่ายและ PDF ส่งเบิก',
  },
  {
    to: '/reports/upsale',
    icon: BadgePercent,
    title: 'อัพเซล',
    desc: 'ยอดขายโปรโมชั่นอัพเซลตามช่วงวันที่ · แยกตามสาขาและพนักงานผู้ขาย · นับจำนวนและคำนวณคอมมิชชั่นของพนักงานแต่ละคน',
  },
  {
    to: '/reports/outstanding',
    icon: HandCoins,
    title: 'ค้างชำระ',
    desc: 'คนไข้ที่ยังค้างชำระเงินกับคลินิก · เรียงจากยอดมากไปน้อย · แยกตามสาขา · กดแถวเพื่อเปิดรายละเอียด แล้วเปิดการรักษาของคนไข้ได้จากในนั้น (คนละส่วนกับ “ค้างรับ” ซึ่งเป็นยอดที่ผู้จ่ายค้างคลินิก)',
  },
  {
    to: '/reports/implant',
    icon: Bone,
    title: 'รากเทียม',
    desc: 'รายชื่อคนไข้ที่ถอนฟันแล้วยังไม่ได้ทดแทน (ไม่รวมผ่าฟันคุด) · แยกเป็นลิสต์ตามระยะเวลาและกลุ่ม · จองสายก่อนโทรเพื่อไม่ให้ซ้ำกับแผนกอื่น · การติดตามว่านัดปรึกษารากเทียมแต่ละนัดไปทางไหน · และคู่มือวิธีทำงานสำหรับทีม',
  },
]

export default function Reports() {
  return (
    <div className="px-10 py-8 max-w-[1100px]">
      <h1 className="text-[22px] font-semibold text-slate-900 tracking-tight mb-1">รายงาน</h1>
      <p className="text-[14px] text-slate-500 mb-7">รายงานและเครื่องมือสำหรับการตรวจสอบ</p>

      <div className="grid gap-4 sm:grid-cols-2">
        {TOOLS.map(({ to, icon: Icon, title, desc }) => (
          <Link
            key={to}
            to={to}
            className="group rounded-2xl border border-slate-200 bg-white p-5 shadow-sm hover:border-brand-300 hover:shadow-md transition flex items-start gap-4"
          >
            <div className="w-11 h-11 rounded-xl bg-brand-50 text-brand-600 flex items-center justify-center shrink-0">
              <Icon size={22} strokeWidth={1.75} />
            </div>
            <div className="min-w-0 flex-1">
              <div className="flex items-center gap-1 text-[15.5px] font-semibold text-slate-900">
                {title}
                <ChevronRight size={16} className="text-slate-300 group-hover:text-brand-400 transition" />
              </div>
              <p className="text-[13px] text-slate-500 mt-1 leading-relaxed">{desc}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  )
}
